<template>
  <div
    class="panel"
    style="flex: 1 0 100%"
  >
    <div class="panel-heading flex-header">
      <slot name="header" />
    </div>

    <div class="panel-body flex-body">
      <template v-if="loading">
        <div style="text-align:center">
          <i
            style="margin-top:10px;"
            class="fa fa-2x fa-spinner fa-spin"
          />
        </div>
      </template>

      <template v-else>
        <p v-if="numberOfEvents === 0">
          {{ trans('series.no_events') }}
        </p>
        <template v-if="showLessons">
          <event-cluster />
        </template>

        <template v-else>
          <template v-for="event_serie in event_series">
            <template>
              <slot :name="'explanationGroups' + event_serie.id" />
            </template>

            <div class="flex-body-component col-xs-12">
              <event-cluster
                v-for="clusterId in clustersOfSerie(event_serie)"
                :key="clusterId"
                :cluster-id="clusterId"
              />
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>

import EventCluster from './EventCluster.vue'

export default {

  name: 'EventSeriesPreview',
  components: { EventCluster },

  computed: {

    loading () {
      return this.$store.state.eventSeries.loading
    },

    showLessons () {
      return this.$store.state.steps.active_step[0]?.lessonSelector === true || Object.keys(this.event_series).length === 0
    },

    event_series () {
      return this.$store.state.eventSeries.event_series
    },

    allowShopping () {
      return this.$store.state.eventSeries.serie_rules.allow_shopping
    },

    numberOfEvents () {
      let courses = this.$store.state.eventSeries.course_event_ids
      let number = 0
      Object.values(courses).forEach(course => {
        number = number + course.length
      })
      return number
    },
  },

  methods: {
    clustersOfSerie (event_serie) {
      return Object.values(event_serie.relationships.eventClusters.data).map(cluster => {
        return cluster.id
      })
    },
  },
}
</script>

<style>
    .event-block {
        border: 1px solid #222;
        padding: 10px 5px;
        margin: 5px 0px;
    }

    .flex-box {
        display: flex;
        flex: 0 0 auto;
        height: 250px;
        flex-direction: column;
        padding: 0px;
        margin-bottom: 0px;
    }

    .flex-header {
        flex: 0 0 50px;
        overflow: hidden;
    }

    .flex-body {
        flex: 1 1 auto;
        overflow: auto;
    }

    .flex-body-component {
        display: flex;
        flex-flow: row nowrap;
    }
</style>
